var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 my-5 d-flex justify-content-center" },
    [
      _c("hollow-dots-spinner", {
        attrs: {
          "animation-duration": 1000,
          color: "#4F842C",
          "dot-size": 15,
          "dots-num": 3
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }